// src/components/SolarQuiz/quizData.js

export const quizStages = [
  {
    level: 1,
    title: "Easy",
    rankTitle: "Solar Novice",
    questions: [
      {
      question: "What does PV stand for in solar energy?",
      options: ["Photovoltaic", "Power Voltage", "Panel Volt", "Photo Variable"],
      correct: "Photovoltaic",
    },
    {
      question: "What is the main function of a solar panel?",
      options: ["Generate light", "Store energy", "Convert sunlight to electricity", "Cool batteries"],
      correct: "Convert sunlight to electricity",
    },
    {
      question: "Which of the following is a renewable energy source?",
      options: ["Coal", "Solar", "Diesel", "Natural gas"],
      correct: "Solar",
    },
    {
      question: "What device converts DC power from solar panels into AC power?",
      options: ["Transformer", "Converter", "Inverter", "Rectifier"],
      correct: "Inverter",
    },
    {
      question: "What is the unit of electrical power?",
      options: ["Watt", "Volt", "Ampere", "Ohm"],
      correct: "Watt",
    },
    {
      question: "Which part of the solar system stores energy for later use?",
      options: ["Battery", "Inverter", "Panel", "Controller"],
      correct: "Battery",
    },
    {
      question: "Solar panels work best when placed in what type of area?",
      options: ["Shaded", "Sunny", "Windy", "Rainy"],
      correct: "Sunny",
    },
    {
      question: "Which of these is a common type of solar panel?",
      options: ["Monocrystalline", "Copper", "Aluminium", "Mercury"],
      correct: "Monocrystalline",
    },
    {
      question: "What component regulates the voltage and current from solar panels to the battery?",
      options: ["Charge controller", "Inverter", "Switch", "Resistor"],
      correct: "Charge controller",
    },
    {
      question: "What happens to solar panels at night?",
      options: ["They produce electricity", "They store more power", "They stop producing electricity", "They increase output"],
      correct: "They stop producing electricity",
    },
    {
      question: "What kind of current do solar panels produce?",
      options: ["AC", "DC", "Both AC and DC", "Static"],
      correct: "DC",
    },
    {
      question: "What factor most affects solar panel efficiency?",
      options: ["Sunlight", "Wind speed", "Rainfall", "Moonlight"],
      correct: "Sunlight",
    },
    {
      question: "What is used to measure electrical energy consumption?",
      options: ["Energy meter", "Thermometer", "Hydrometer", "Altimeter"],
      correct: "Energy meter",
    },
    {
      question: "What is the average lifespan of a quality solar panel?",
      options: ["5 years", "10 years", "25 years", "1 year"],
      correct: "25 years",
    },
    {
      question: "Which of these appliances can easily run on a small solar system?",
      options: ["LED bulb", "Air conditioner", "Electric cooker", "Freezer"],
      correct: "LED bulb",
    },
    {
      question: "What is the main raw material used in making solar cells?",
      options: ["Silicon", "Iron", "Copper", "Zinc"],
      correct: "Silicon",
    },
    {
      question: "What is the function of an inverter in a solar system?",
      options: ["Stores power", "Converts DC to AC", "Generates sunlight", "Measures voltage"],
      correct: "Converts DC to AC",
    },
    {
      question: "What determines the size of a solar system you need?",
      options: ["Number of appliances", "Roof color", "Battery shape", "Cable type"],
      correct: "Number of appliances",
    },
    {
      question: "What is a solar array?",
      options: ["A single panel", "A group of connected solar panels", "A type of inverter", "A power switch"],
      correct: "A group of connected solar panels",
    },
    {
      question: "What time of day do solar panels produce the most energy?",
      options: ["Morning", "Noon", "Evening", "Night"],
      correct: "Noon",
    },
      // ...18 more
    ],
  },

  {
  level: 2,
  title: "Moderate",
  rankTitle: "Solar Learner",
  questions: [
    {
      question: "What does the efficiency of a solar panel indicate?",
      options: [
        "How long it lasts",
        "How well it converts sunlight into electricity",
        "How large the panel is",
        "How much it costs"
      ],
      correct: "How well it converts sunlight into electricity",
    },
    {
      question: "What is the standard test condition (STC) used for rating solar panels?",
      options: [
        "1000W/m², 25°C, AM 1.5",
        "500W/m², 30°C, AM 1.5",
        "1200W/m², 20°C, AM 2.0",
        "800W/m², 35°C, AM 1.2"
      ],
      correct: "1000W/m², 25°C, AM 1.5",
    },
    {
      question: "Which component prevents the battery from overcharging?",
      options: [
        "Charge controller",
        "Inverter",
        "Breaker",
        "Junction box"
      ],
      correct: "Charge controller",
    },
    {
      question: "What type of battery is commonly used in solar systems?",
      options: [
        "Lithium-ion",
        "Nickel-cadmium",
        "Alkaline",
        "Lead-acid"
      ],
      correct: "Lithium-ion",
    },
    {
      question: "What is the typical voltage of a solar panel used in residential systems?",
      options: [
        "5V",
        "12V",
        "48V",
        "120V"
      ],
      correct: "12V",
    },
    {
      question: "What does MPPT stand for in charge controllers?",
      options: [
        "Maximum Power Point Tracking",
        "Minimum Power Point Tuning",
        "Main Power Phase Transformer",
        "Mega Panel Performance Tracker"
      ],
      correct: "Maximum Power Point Tracking",
    },
    {
      question: "Which factor does NOT affect solar panel output?",
      options: [
        "Temperature",
        "Sun angle",
        "Panel color",
        "Cable length"
      ],
      correct: "Panel color",
    },
    {
      question: "What is the function of a fuse in a solar system?",
      options: [
        "To boost power",
        "To protect against overcurrent",
        "To increase voltage",
        "To regulate sunlight"
      ],
      correct: "To protect against overcurrent",
    },
    {
      question: "What is the typical unit used to measure battery capacity?",
      options: [
        "Volt",
        "Watt-hour",
        "Ampere-hour",
        "Ohm"
      ],
      correct: "Ampere-hour",
    },
    {
      question: "What type of inverter can synchronize with the grid?",
      options: [
        "Hybrid inverter",
        "Off-grid inverter",
        "Micro inverter",
        "String inverter"
      ],
      correct: "Hybrid inverter",
    },
    {
      question: "What happens if solar panels are connected in series?",
      options: [
        "Voltage increases, current stays the same",
        "Current increases, voltage stays the same",
        "Both voltage and current decrease",
        "Both voltage and current increase"
      ],
      correct: "Voltage increases, current stays the same",
    },
    {
      question: "What happens if solar panels are connected in parallel?",
      options: [
        "Voltage increases, current stays the same",
        "Current increases, voltage stays the same",
        "Both decrease",
        "Both increase"
      ],
      correct: "Current increases, voltage stays the same",
    },
    {
      question: "What is the main purpose of grounding in a solar installation?",
      options: [
        "To improve voltage",
        "To protect from electrical shock and lightning",
        "To reduce current",
        "To balance energy flow"
      ],
      correct: "To protect from electrical shock and lightning",
    },
    {
      question: "Which of these determines how much sunlight hits a solar panel?",
      options: [
        "Tilt angle and orientation",
        "Panel thickness",
        "Cable size",
        "Panel warranty"
      ],
      correct: "Tilt angle and orientation",
    },
    {
      question: "What is the function of a junction box in a solar panel?",
      options: [
        "Stores electricity",
        "Houses the bypass diodes and connections",
        "Measures current",
        "Increases voltage"
      ],
      correct: "Houses the bypass diodes and connections",
    },
    {
      question: "What is the typical output voltage of a 60-cell solar panel?",
      options: [
        "10V",
        "18V–20V",
        "35V–40V",
        "60V"
      ],
      correct: "35V–40V",
    },
    {
      question: "Which type of solar charge controller is more efficient?",
      options: [
        "PWM",
        "MPPT",
        "Linear",
        "Analog"
      ],
      correct: "MPPT",
    },
    {
      question: "What does a solar inverter display usually show?",
      options: [
        "Panel weight and height",
        "Voltage, current, and power output",
        "Battery acid level",
        "Temperature of the sun"
      ],
      correct: "Voltage, current, and power output",
    },
    {
      question: "What is the main difference between on-grid and off-grid systems?",
      options: [
        "Battery size",
        "Connection to the utility grid",
        "Panel color",
        "Type of inverter used"
      ],
      correct: "Connection to the utility grid",
    },
    {
      question: "What is solar irradiation measured in?",
      options: [
        "Watts per square meter",
        "Amperes per meter",
        "Joules per second",
        "Kelvin per hour"
      ],
      correct: "Watts per square meter",
    },
  ],
},


  {
  level: 3,
  title: "Intermediate",
  rankTitle: "Solar Apprentice",
  questions: [
    {
      question: "What is the function of bypass diodes in a solar panel?",
      options: [
        "Prevent current from flowing backward through shaded cells",
        "Increase current output",
        "Store excess energy",
        "Convert DC to AC"
      ],
      correct: "Prevent current from flowing backward through shaded cells",
    },
    {
      question: "What does the tilt angle of a solar panel primarily affect?",
      options: [
        "Aesthetic appearance",
        "Power output efficiency",
        "Panel lifespan",
        "Temperature of the inverter"
      ],
      correct: "Power output efficiency",
    },
    {
      question: "What is the main purpose of a combiner box in solar installation?",
      options: [
        "To combine outputs from multiple strings of solar panels",
        "To convert DC to AC",
        "To store extra energy",
        "To ground the panels"
      ],
      correct: "To combine outputs from multiple strings of solar panels",
    },
    {
      question: "Which type of inverter is best suited for shaded roofs with multiple orientations?",
      options: [
        "Micro inverter",
        "String inverter",
        "Central inverter",
        "Hybrid inverter"
      ],
      correct: "Micro inverter",
    },
    {
      question: "What does VOC stand for in solar panel specifications?",
      options: [
        "Voltage Open Circuit",
        "Voltage of Current",
        "Variable Output Capacity",
        "Voltage Output Control"
      ],
      correct: "Voltage Open Circuit",
    },
    {
      question: "If a panel produces 10A at 40V, what is its power output?",
      options: [
        "400W",
        "4W",
        "40W",
        "10W"
      ],
      correct: "400W",
    },
    {
      question: "What happens to battery life if it is frequently over-discharged?",
      options: [
        "It lasts longer",
        "It gets damaged faster",
        "It increases capacity",
        "It charges faster"
      ],
      correct: "It gets damaged faster",
    },
    {
      question: "What does DoD stand for in battery specifications?",
      options: [
        "Depth of Discharge",
        "Degree of Displacement",
        "Duration of Discharge",
        "Depth of Density"
      ],
      correct: "Depth of Discharge",
    },
    {
      question: "Which factor most reduces solar panel performance over time?",
      options: [
        "Degradation rate",
        "Cable length",
        "Battery temperature",
        "Rainfall"
      ],
      correct: "Degradation rate",
    },
    {
      question: "Which of the following indicates battery health in solar systems?",
      options: [
        "Voltage and charge cycle count",
        "Cable thickness",
        "Panel orientation",
        "Inverter wattage"
      ],
      correct: "Voltage and charge cycle count",
    },
    {
      question: "What is the main advantage of a hybrid solar system?",
      options: [
        "It can work both on-grid and off-grid",
        "It doesn’t need an inverter",
        "It uses fewer panels",
        "It requires no battery"
      ],
      correct: "It can work both on-grid and off-grid",
    },
    {
      question: "What is the main cause of voltage drop in solar wiring?",
      options: [
        "Long cable runs and small wire size",
        "Panel temperature",
        "Inverter settings",
        "Panel orientation"
      ],
      correct: "Long cable runs and small wire size",
    },
    {
      question: "What is the typical frequency of AC output in most inverters?",
      options: [
        "50 Hz",
        "25 Hz",
        "100 Hz",
        "60 Amps"
      ],
      correct: "50 Hz",
    },
    {
      question: "Which solar cell technology performs better in low-light conditions?",
      options: [
        "Monocrystalline",
        "Polycrystalline",
        "Thin-film",
        "PERC"
      ],
      correct: "Thin-film",
    },
    {
      question: "What device disconnects a solar system during maintenance or faults?",
      options: [
        "Isolator switch",
        "Charge controller",
        "MC4 connector",
        "Fuse"
      ],
      correct: "Isolator switch",
    },
    {
      question: "What is a solar inverter’s main efficiency range?",
      options: [
        "85% - 95%",
        "45% - 60%",
        "60% - 75%",
        "98% - 100%"
      ],
      correct: "85% - 95%",
    },
    {
      question: "Which of these factors most affects battery charging efficiency?",
      options: [
        "Temperature",
        "Cable color",
        "Panel shape",
        "Fuse type"
      ],
      correct: "Temperature",
    },
    {
      question: "What is the role of a DC isolator in a PV system?",
      options: [
        "Disconnect DC power between panels and inverter",
        "Convert DC to AC",
        "Increase voltage output",
        "Regulate battery charge"
      ],
      correct: "Disconnect DC power between panels and inverter",
    },
    {
      question: "What is the advantage of using thicker solar cables?",
      options: [
        "Reduces voltage drop and heat buildup",
        "Increases sunlight capture",
        "Improves panel color",
        "Boosts inverter speed"
      ],
      correct: "Reduces voltage drop and heat buildup",
    },
    {
      question: "Which of these helps prevent battery overcharging and deep discharge?",
      options: [
        "Solar charge controller",
        "Inverter",
        "MC4 connector",
        "Fuse"
      ],
      correct: "Solar charge controller",
    },
  ],
},

  {
  level: 4,
  title: "Upper Intermediate",
  rankTitle: "Solar Worker",
  questions: [
    {
      question: "What does the term ‘array configuration’ refer to in solar design?",
      options: [
        "The physical layout and electrical connection of solar panels",
        "The shape of the battery bank",
        "The type of charge controller used",
        "The cable color arrangement"
      ],
      correct: "The physical layout and electrical connection of solar panels",
    },
    {
      question: "What is the main purpose of using MC4 connectors?",
      options: [
        "To easily and safely connect solar panel wires",
        "To increase panel efficiency",
        "To measure current output",
        "To store DC power"
      ],
      correct: "To easily and safely connect solar panel wires",
    },
    {
      question: "How is solar system capacity usually expressed?",
      options: [
        "In kilowatts peak (kWp)",
        "In volts",
        "In amps",
        "In joules"
      ],
      correct: "In kilowatts peak (kWp)",
    },
    {
      question: "What is the typical open-circuit voltage range for a 72-cell panel?",
      options: [
        "40V–48V",
        "10V–15V",
        "60V–80V",
        "90V–100V"
      ],
      correct: "40V–48V",
    },
    {
      question: "If solar irradiance drops by 50%, how does panel output change approximately?",
      options: [
        "It drops by 50%",
        "It doubles",
        "It remains constant",
        "It increases slightly"
      ],
      correct: "It drops by 50%",
    },
    {
      question: "What type of inverter architecture allows one inverter per panel?",
      options: [
        "Micro inverter",
        "String inverter",
        "Central inverter",
        "Hybrid inverter"
      ],
      correct: "Micro inverter",
    },
    {
      question: "Which factor determines the total energy a solar system can generate daily?",
      options: [
        "Peak sun hours",
        "Panel brand",
        "Battery voltage",
        "Cable length"
      ],
      correct: "Peak sun hours",
    },
    {
      question: "What is the term for energy loss due to resistance in wiring?",
      options: [
        "Voltage drop",
        "Ampere gain",
        "Power surge",
        "Reactive loss"
      ],
      correct: "Voltage drop",
    },
    {
      question: "Which of these helps improve system reliability in large installations?",
      options: [
        "Using multiple MPPT inputs",
        "Using fewer panels",
        "Reducing battery capacity",
        "Mixing panel types"
      ],
      correct: "Using multiple MPPT inputs",
    },
    {
      question: "What is the function of surge protection devices (SPDs) in solar systems?",
      options: [
        "To protect equipment from voltage spikes or lightning",
        "To convert AC to DC",
        "To boost battery voltage",
        "To reduce inverter noise"
      ],
      correct: "To protect equipment from voltage spikes or lightning",
    },
    {
      question: "Which of these solar system types requires anti-islanding protection?",
      options: [
        "Grid-tied system",
        "Off-grid system",
        "Hybrid system",
        "Portable solar kit"
      ],
      correct: "Grid-tied system",
    },
    {
      question: "What happens to inverter efficiency when it is underloaded?",
      options: [
        "Efficiency decreases",
        "Efficiency increases",
        "Remains constant",
        "Voltage output increases"
      ],
      correct: "Efficiency decreases",
    },
    {
      question: "Which type of loss occurs when converting DC to AC in inverters?",
      options: [
        "Conversion loss",
        "Voltage drop",
        "Line loss",
        "Thermal loss"
      ],
      correct: "Conversion loss",
    },
    {
      question: "What does C-rate describe in battery specifications?",
      options: [
        "The rate at which a battery charges or discharges",
        "The cost of the battery",
        "The temperature tolerance",
        "The current regulation capacity"
      ],
      correct: "The rate at which a battery charges or discharges",
    },
    {
      question: "Which of the following reduces battery lifespan the most?",
      options: [
        "High temperature and deep discharge",
        "Shallow discharge",
        "Cool environment",
        "Moderate charging"
      ],
      correct: "High temperature and deep discharge",
    },
    {
      question: "Why are fuses and circuit breakers used in PV systems?",
      options: [
        "To prevent damage from overcurrent or short circuits",
        "To increase voltage",
        "To store backup power",
        "To measure power output"
      ],
      correct: "To prevent damage from overcurrent or short circuits",
    },
    {
      question: "Which cable size will reduce losses in a 30A solar circuit the most?",
      options: [
        "10mm²",
        "2.5mm²",
        "4mm²",
        "6mm²"
      ],
      correct: "10mm²",
    },
    {
      question: "What is the function of a solar combiner box fuse?",
      options: [
        "To protect each string from reverse current flow",
        "To store excess energy",
        "To increase inverter output",
        "To control charge voltage"
      ],
      correct: "To protect each string from reverse current flow",
    },
    {
      question: "What is the approximate voltage of a 24V battery bank fully charged?",
      options: [
        "25.6V–26.8V",
        "20.0V",
        "28.5V–30.0V",
        "22.0V"
      ],
      correct: "25.6V–26.8V",
    },
    {
      question: "What happens if solar panels of different wattages are connected in series?",
      options: [
        "The lowest-rated panel limits the current of the entire string",
        "The total output increases drastically",
        "Each panel outputs independently",
        "Voltage decreases linearly"
      ],
      correct: "The lowest-rated panel limits the current of the entire string",
    },
  ],
},


  {
  level: 5,
  title: "Advanced",
  rankTitle: "Solar Technician",
  questions: [
    {
      question: "What does the term ‘derating factor’ mean in solar system design?",
      options: [
        "The percentage reduction in system performance due to losses",
        "The total energy output of the array",
        "The capacity of the inverter",
        "The lifespan of the solar panels"
      ],
      correct: "The percentage reduction in system performance due to losses",
    },
    {
      question: "What is the recommended temperature coefficient for high-quality solar panels?",
      options: [
        "-0.3%/°C or lower",
        "-1.0%/°C or higher",
        "+0.5%/°C",
        "0%/°C"
      ],
      correct: "-0.3%/°C or lower",
    },
    {
      question: "What happens when PV modules are exposed to higher temperatures?",
      options: [
        "Voltage output decreases",
        "Current drops significantly",
        "Voltage output increases",
        "Efficiency improves"
      ],
      correct: "Voltage output decreases",
    },
    {
      question: "Which device converts high DC voltage to grid-compatible AC in large installations?",
      options: [
        "Central inverter",
        "Micro inverter",
        "Charge controller",
        "Hybrid inverter"
      ],
      correct: "Central inverter",
    },
    {
      question: "In solar system design, what does load analysis help determine?",
      options: [
        "The total power requirement for system sizing",
        "The color of panels to install",
        "The efficiency of inverter cooling",
        "The wiring configuration"
      ],
      correct: "The total power requirement for system sizing",
    },
    {
      question: "What is the effect of using undersized cables in a PV system?",
      options: [
        "Increased voltage drop and overheating",
        "Improved energy transfer",
        "Reduced power losses",
        "Higher inverter efficiency"
      ],
      correct: "Increased voltage drop and overheating",
    },
    {
      question: "What is the typical voltage output of a 96-cell solar panel?",
      options: [
        "45–48V",
        "20–25V",
        "55–60V",
        "35–38V"
      ],
      correct: "45–48V",
    },
    {
      question: "Which component ensures equal charging of multiple batteries connected in parallel?",
      options: [
        "Battery balancer",
        "Charge controller",
        "Inverter",
        "Combiner box"
      ],
      correct: "Battery balancer",
    },
    {
      question: "What is the purpose of installing a lightning arrestor in a solar system?",
      options: [
        "To divert surge current from lightning to the ground",
        "To increase system voltage",
        "To stabilize the inverter",
        "To regulate battery charging"
      ],
      correct: "To divert surge current from lightning to the ground",
    },
    {
      question: "How can you increase the current output of a solar array?",
      options: [
        "Connect panels in parallel",
        "Connect panels in series",
        "Add more inverters",
        "Reduce cable thickness"
      ],
      correct: "Connect panels in parallel",
    },
    {
      question: "Which factor determines how much power an inverter can handle?",
      options: [
        "Rated wattage of the inverter",
        "Battery size",
        "Cable thickness",
        "Solar irradiance"
      ],
      correct: "Rated wattage of the inverter",
    },
    {
      question: "Which unit is commonly used to measure solar irradiation over a day?",
      options: [
        "kWh/m²/day",
        "Amps/hour",
        "Joules/second",
        "Lux/m²"
      ],
      correct: "kWh/m²/day",
    },
    {
      question: "What is the primary safety device between the inverter and the battery bank?",
      options: [
        "DC circuit breaker",
        "MC4 connector",
        "MPPT controller",
        "SPD"
      ],
      correct: "DC circuit breaker",
    },
    {
      question: "What is the purpose of a monitoring system in a solar plant?",
      options: [
        "To track performance and detect faults in real-time",
        "To regulate panel temperature",
        "To adjust cable resistance",
        "To control battery electrolyte levels"
      ],
      correct: "To track performance and detect faults in real-time",
    },
    {
      question: "Which battery type allows for the deepest discharge cycles?",
      options: [
        "Lithium-ion",
        "Lead-acid",
        "Nickel-metal hydride",
        "Calcium"
      ],
      correct: "Lithium-ion",
    },
    {
      question: "What is the major cause of inverter shutdown during peak sunlight?",
      options: [
        "Overvoltage from panels",
        "Low battery voltage",
        "MPPT malfunction",
        "High grid frequency"
      ],
      correct: "Overvoltage from panels",
    },
    {
      question: "Why is it important to match inverter voltage range with PV array voltage?",
      options: [
        "To ensure proper operation and prevent inverter damage",
        "To reduce inverter cost",
        "To improve battery charging speed",
        "To increase grid voltage"
      ],
      correct: "To ensure proper operation and prevent inverter damage",
    },
    {
      question: "What is the main function of a PV surge protection device (SPD)?",
      options: [
        "To protect the system from transient voltage spikes",
        "To balance current flow between panels",
        "To improve inverter speed",
        "To stabilize solar irradiance"
      ],
      correct: "To protect the system from transient voltage spikes",
    },
    {
      question: "Which environmental condition has the greatest negative effect on solar efficiency?",
      options: [
        "High temperature",
        "Low humidity",
        "Moderate wind",
        "Cool conditions"
      ],
      correct: "High temperature",
    },
    {
      question: "What is the purpose of a battery management system (BMS)?",
      options: [
        "To monitor and protect batteries from overcharge, over-discharge, and overheating",
        "To convert DC to AC",
        "To combine battery voltages",
        "To regulate inverter speed"
      ],
      correct: "To monitor and protect batteries from overcharge, over-discharge, and overheating",
    },
  ],
},



{
  level: 6,
  title: "Expert",
  rankTitle: "Solar Engineer",
  questions: [
    {
      question: "What is the main reason for limiting the number of PV modules per string?",
      options: [
        "To stay within the inverter’s maximum input voltage limit",
        "To balance array weight distribution",
        "To match current output of batteries",
        "To improve charge controller speed"
      ],
      correct: "To stay within the inverter’s maximum input voltage limit",
    },
    {
      question: "What is the effect of connecting panels with different tilt angles in the same string?",
      options: [
        "Reduced overall energy output due to mismatch losses",
        "Increased total current output",
        "Improved efficiency during cloudy days",
        "No effect if the panels face the same direction"
      ],
      correct: "Reduced overall energy output due to mismatch losses",
    },
    {
      question: "What parameter must be considered to ensure proper inverter synchronization with the grid?",
      options: [
        "Phase, frequency, and voltage matching",
        "Battery depth of discharge",
        "Temperature coefficient",
        "Cable insulation rating"
      ],
      correct: "Phase, frequency, and voltage matching",
    },
    {
      question: "When designing a solar plant, what is the function of an isolation transformer?",
      options: [
        "To separate the DC and AC sides for safety and grid compliance",
        "To boost inverter efficiency",
        "To increase solar voltage",
        "To store excess energy"
      ],
      correct: "To separate the DC and AC sides for safety and grid compliance",
    },
    {
      question: "In PV system fault analysis, what does an 'open-circuit fault' in a string cause?",
      options: [
        "Complete loss of current flow in that string",
        "Overvoltage to the inverter",
        "Current surge to other strings",
        "Partial shading on all panels"
      ],
      correct: "Complete loss of current flow in that string",
    },
    {
      question: "What happens if solar panels are connected in reverse polarity?",
      options: [
        "The inverter or charge controller may be damaged",
        "The voltage increases",
        "The system produces double the power",
        "Nothing happens if connected to a fuse"
      ],
      correct: "The inverter or charge controller may be damaged",
    },
    {
      question: "What is the primary function of a combiner box in a PV system?",
      options: [
        "To combine multiple PV strings into one output with protection",
        "To connect inverter to grid",
        "To regulate inverter temperature",
        "To store DC energy"
      ],
      correct: "To combine multiple PV strings into one output with protection",
    },
    {
      question: "Why is grounding essential in a PV installation?",
      options: [
        "To provide a safe path for fault current and prevent electric shock",
        "To improve current flow efficiency",
        "To boost panel voltage",
        "To balance solar charge rates"
      ],
      correct: "To provide a safe path for fault current and prevent electric shock",
    },
    {
      question: "What is the typical open-circuit voltage tolerance of a solar module under Standard Test Conditions (STC)?",
      options: [
        "±3%",
        "±10%",
        "±1%",
        "±5%"
      ],
      correct: "±3%",
    },
    {
      question: "What determines the number of panels you can safely connect in parallel?",
      options: [
        "The current-carrying capacity of cables and fuses",
        "The voltage rating of each panel",
        "The number of MPPT inputs",
        "The size of inverter fan"
      ],
      correct: "The current-carrying capacity of cables and fuses",
    },
    {
      question: "What is the significance of I-V curve testing in solar systems?",
      options: [
        "To verify the real performance and detect faulty modules",
        "To measure inverter output frequency",
        "To test ground resistance",
        "To determine grid synchronization"
      ],
      correct: "To verify the real performance and detect faulty modules",
    },
    {
      question: "Which device prevents reverse current flow from batteries to solar panels at night?",
      options: [
        "Blocking diode",
        "DC fuse",
        "SPD",
        "Battery balancer"
      ],
      correct: "Blocking diode",
    },
    {
      question: "What is the impact of high power factor (close to 1.0) in a grid-tied system?",
      options: [
        "Efficient energy transfer with minimal losses",
        "Reduced inverter lifespan",
        "Increased voltage harmonics",
        "Higher temperature on PV cables"
      ],
      correct: "Efficient energy transfer with minimal losses",
    },
    {
      question: "Which standard typically governs the installation of solar photovoltaic systems?",
      options: [
        "IEC 60364 or equivalent national codes",
        "ISO 14001",
        "IEEE 802.11",
        "NFPA 25"
      ],
      correct: "IEC 60364 or equivalent national codes",
    },
    {
      question: "What is string mismatch loss?",
      options: [
        "Loss caused by unequal current generation between strings",
        "Loss from inverter idling",
        "Power loss from long cables",
        "Voltage drop between panels and battery"
      ],
      correct: "Loss caused by unequal current generation between strings",
    },
    {
      question: "Why is maximum string voltage checked under coldest expected temperature?",
      options: [
        "Because lower temperature increases panel voltage output",
        "Because cold reduces inverter efficiency",
        "Because inverter fans may fail in cold conditions",
        "Because batteries charge faster when cold"
      ],
      correct: "Because lower temperature increases panel voltage output",
    },
    {
      question: "What does 'anti-islanding protection' in a grid-tied inverter do?",
      options: [
        "It disconnects the system when the grid fails to protect line workers",
        "It prevents lightning surges",
        "It maintains inverter cooling",
        "It limits inverter voltage"
      ],
      correct: "It disconnects the system when the grid fails to protect line workers",
    },
    {
      question: "What is the function of a PV junction box on the back of a solar panel?",
      options: [
        "It houses bypass diodes and connection terminals",
        "It measures solar intensity",
        "It holds the panel frame",
        "It balances charge flow between panels"
      ],
      correct: "It houses bypass diodes and connection terminals",
    },
    {
      question: "Why are bypass diodes used in solar modules?",
      options: [
        "To prevent hot spots and power loss during partial shading",
        "To increase voltage output",
        "To combine current from multiple strings",
        "To regulate battery voltage"
      ],
      correct: "To prevent hot spots and power loss during partial shading",
    },
    {
      question: "What is the acceptable voltage drop limit for DC cables in a well-designed PV system?",
      options: [
        "Less than 3%",
        "Up to 10%",
        "Exactly 5%",
        "Zero voltage drop"
      ],
      correct: "Less than 3%",
    },
  ],
},


{
  level: 7,
  title: "Professional",
  rankTitle: "Solar System Designer",
  questions: [
    {
      question: "What is the primary design objective of string sizing in a PV array?",
      options: [
        "To ensure the string voltage stays within inverter MPPT range in all conditions",
        "To reduce cable costs by using shorter strings",
        "To minimize inverter fan operation",
        "To balance inverter power factor"
      ],
      correct: "To ensure the string voltage stays within inverter MPPT range in all conditions",
    },
    {
      question: "What is the main difference between DC-coupled and AC-coupled hybrid systems?",
      options: [
        "DC-coupled systems connect batteries before the inverter, AC-coupled after the inverter",
        "AC-coupled systems cannot use grid power",
        "DC-coupled systems require two inverters",
        "AC-coupled systems only work off-grid"
      ],
      correct: "DC-coupled systems connect batteries before the inverter, AC-coupled after the inverter",
    },
    {
      question: "What software is commonly used for solar PV system simulation and energy yield estimation?",
      options: [
        "PVsyst",
        "AutoCAD",
        "MATLAB",
        "ETAP"
      ],
      correct: "PVsyst",
    },
    {
      question: "In grid-tied PV systems, what does 'export limitation' mean?",
      options: [
        "Restricting the amount of power sent back to the grid",
        "Preventing solar from charging batteries",
        "Blocking DC surge from inverter",
        "Reducing PV array voltage"
      ],
      correct: "Restricting the amount of power sent back to the grid",
    },
    {
      question: "Which factor most influences the inverter clipping losses?",
      options: [
        "Oversizing the PV array beyond inverter AC rating",
        "Using longer DC cables",
        "Panel degradation",
        "Ambient temperature"
      ],
      correct: "Oversizing the PV array beyond inverter AC rating",
    },
    {
      question: "What is the primary function of a surge protection device (SPD) in PV systems?",
      options: [
        "To protect equipment from transient overvoltages caused by lightning or switching",
        "To regulate inverter speed",
        "To control reactive power flow",
        "To block backfeed current"
      ],
      correct: "To protect equipment from transient overvoltages caused by lightning or switching",
    },
    {
      question: "What does the term 'balance of system (BOS)' include in PV design?",
      options: [
        "All components excluding the PV modules (cables, switches, combiner boxes, etc.)",
        "Only batteries and inverter",
        "Only the solar panels",
        "Grid connection transformer"
      ],
      correct: "All components excluding the PV modules (cables, switches, combiner boxes, etc.)",
    },
    {
      question: "What is the main cause of mismatch losses between PV modules in an array?",
      options: [
        "Differences in module characteristics and irradiance levels",
        "Variation in inverter voltage range",
        "Poor battery health",
        "Incorrect cable polarity"
      ],
      correct: "Differences in module characteristics and irradiance levels",
    },
    {
      question: "In PV system monitoring, what does 'Performance Ratio (PR)' represent?",
      options: [
        "The ratio of actual system output to expected output under standard conditions",
        "The inverter’s power factor",
        "The efficiency of solar panels only",
        "The ratio of inverter DC to AC efficiency"
      ],
      correct: "The ratio of actual system output to expected output under standard conditions",
    },
    {
      question: "What is the purpose of array layout optimization?",
      options: [
        "To maximize energy yield by minimizing shading and losses",
        "To reduce visual appearance of the system",
        "To lower inverter cost",
        "To decrease wiring resistance"
      ],
      correct: "To maximize energy yield by minimizing shading and losses",
    },
    {
      question: "What is the recommended DC-to-AC ratio range for PV system design?",
      options: [
        "Between 1.1 and 1.4",
        "Below 0.8",
        "Above 2.0",
        "Exactly 1.0"
      ],
      correct: "Between 1.1 and 1.4",
    },
    {
      question: "What is the most accurate way to calculate solar resource for system design?",
      options: [
        "Using satellite or ground-based irradiance data specific to the site",
        "Assuming 5 peak sun hours per day",
        "Measuring temperature variation only",
        "Using default values from inverter manual"
      ],
      correct: "Using satellite or ground-based irradiance data specific to the site",
    },
    {
      question: "What does 'soiling loss' in PV systems refer to?",
      options: [
        "Energy loss due to dirt, dust, or bird droppings on panels",
        "Cable loss caused by heat",
        "Power loss due to inverter clipping",
        "Current loss due to shading"
      ],
      correct: "Energy loss due to dirt, dust, or bird droppings on panels",
    },
    {
      question: "Why are PV panels often installed with a tilt equal to the site's latitude?",
      options: [
        "To maximize annual solar energy capture",
        "To reduce wind resistance",
        "To improve water drainage",
        "To simplify installation"
      ],
      correct: "To maximize annual solar energy capture",
    },
    {
      question: "What is the main purpose of using string fuses or circuit breakers in a PV combiner box?",
      options: [
        "To isolate faulty strings and prevent overcurrent",
        "To improve voltage gain",
        "To cool PV modules",
        "To boost AC power"
      ],
      correct: "To isolate faulty strings and prevent overcurrent",
    },
    {
      question: "What happens to a PV system if the inverter’s MPPT range does not match the array voltage?",
      options: [
        "Energy harvest efficiency reduces significantly",
        "Panels overheat and fail immediately",
        "System continues unaffected",
        "Battery lifespan increases"
      ],
      correct: "Energy harvest efficiency reduces significantly",
    },
    {
      question: "What is the typical tolerance range for module power output compared to nameplate rating?",
      options: [
        "±3% to ±5%",
        "±10% to ±15%",
        "±1%",
        "±20%"
      ],
      correct: "±3% to ±5%",
    },
    {
      question: "Why are string inverters often preferred for large rooftop solar systems?",
      options: [
        "They simplify maintenance and reduce mismatch losses",
        "They are cheaper than microinverters",
        "They eliminate the need for fuses",
        "They work better in shaded areas"
      ],
      correct: "They simplify maintenance and reduce mismatch losses",
    },
    {
      question: "In PV design, what is the role of a protection relay in a grid-tied system?",
      options: [
        "To detect abnormal grid conditions and disconnect the inverter",
        "To monitor battery temperature",
        "To balance solar output per phase",
        "To prevent inverter cooling failure"
      ],
      correct: "To detect abnormal grid conditions and disconnect the inverter",
    },
    {
      question: "What is the best method to minimize voltage drop in DC cabling for long distances?",
      options: [
        "Use thicker cables or parallel conductors",
        "Reduce inverter size",
        "Lower system current",
        "Install more fuses"
      ],
      correct: "Use thicker cables or parallel conductors",
    },
  ],
},



{
  level: 8,
  title: "Specialist",
  rankTitle: "Solar Project Consultant",
  questions: [
    {
      question: "What is the purpose of conducting a grid impact study before a large-scale solar plant interconnection?",
      options: [
        "To evaluate how the PV system will affect grid stability, voltage, and power quality",
        "To determine inverter efficiency only",
        "To calculate solar panel tilt angle",
        "To verify PV string length"
      ],
      correct: "To evaluate how the PV system will affect grid stability, voltage, and power quality",
    },
    {
      question: "What is the significance of the Power Factor Correction (PFC) system in a grid-connected solar plant?",
      options: [
        "It minimizes reactive power to maintain grid voltage stability",
        "It increases current to boost inverter output",
        "It stores backup power during outages",
        "It helps MPPT operation at low irradiance"
      ],
      correct: "It minimizes reactive power to maintain grid voltage stability",
    },
    {
      question: "What is the acceptable range of grid frequency variation for most solar inverters before disconnection?",
      options: [
        "±0.5 Hz from nominal frequency",
        "±5 Hz from nominal frequency",
        "±10 Hz from nominal frequency",
        "Exactly 50 Hz fixed"
      ],
      correct: "±0.5 Hz from nominal frequency",
    },
    {
      question: "What is the main purpose of conducting an energy yield assessment (EYA) for a solar project?",
      options: [
        "To estimate annual energy generation based on solar resource and system losses",
        "To determine inverter physical size",
        "To check transformer insulation",
        "To assess visual impact of panels"
      ],
      correct: "To estimate annual energy generation based on solar resource and system losses",
    },
    {
      question: "What does the 'Ground Potential Rise (GPR)' phenomenon describe in solar substations?",
      options: [
        "An increase in earth voltage during fault conditions due to high fault currents",
        "Voltage increase at PV strings during peak sunlight",
        "Thermal rise in earthing conductors",
        "High panel resistance under load"
      ],
      correct: "An increase in earth voltage during fault conditions due to high fault currents",
    },
    {
      question: "What is the key design consideration for selecting a central inverter in a utility-scale plant?",
      options: [
        "High efficiency, modularity, and grid code compliance",
        "Lowest cost only",
        "Ability to operate off-grid",
        "Small size for rooftop use"
      ],
      correct: "High efficiency, modularity, and grid code compliance",
    },
    {
      question: "What does 'harmonic distortion' in a solar system typically result from?",
      options: [
        "Nonlinear loads or inverter switching behavior",
        "Overvoltage in panels",
        "Temperature changes on PV strings",
        "DC grounding faults"
      ],
      correct: "Nonlinear loads or inverter switching behavior",
    },
    {
      question: "What is the advantage of using a single-axis tracking system in large-scale PV plants?",
      options: [
        "It increases daily energy yield by following the sun’s movement",
        "It reduces wiring cost",
        "It cools PV modules automatically",
        "It eliminates need for MPPT"
      ],
      correct: "It increases daily energy yield by following the sun’s movement",
    },
    {
      question: "What is the typical DC/AC ratio used for large utility-scale solar farms?",
      options: [
        "Between 1.2 and 1.5",
        "Exactly 1.0",
        "Below 0.8",
        "Above 2.0"
      ],
      correct: "Between 1.2 and 1.5",
    },
    {
      question: "In project financing, what does the 'P50 energy estimate' represent?",
      options: [
        "The expected annual energy output with a 50% probability of exceedance",
        "The minimum guaranteed production under warranty",
        "The worst-case production scenario",
        "The peak inverter capacity"
      ],
      correct: "The expected annual energy output with a 50% probability of exceedance",
    },
    {
      question: "Why is cable derating applied in PV system design?",
      options: [
        "To adjust for temperature, grouping, and installation conditions affecting current capacity",
        "To improve current flow at night",
        "To increase voltage drop intentionally",
        "To reduce inverter noise"
      ],
      correct: "To adjust for temperature, grouping, and installation conditions affecting current capacity",
    },
    {
      question: "What is the purpose of using an SCADA system in solar power plants?",
      options: [
        "To remotely monitor, control, and log system performance in real time",
        "To convert DC to AC power",
        "To clean panels automatically",
        "To provide backup storage"
      ],
      correct: "To remotely monitor, control, and log system performance in real time",
    },
    {
      question: "What does 'anti-islanding protection' prevent in grid-tied systems?",
      options: [
        "Inverter operation when the grid is down, ensuring safety for line workers",
        "Overcharging of batteries",
        "Reverse power flow to batteries",
        "Voltage imbalance across strings"
      ],
      correct: "Inverter operation when the grid is down, ensuring safety for line workers",
    },
    {
      question: "What type of transformer is commonly used in large solar plants to connect to the grid?",
      options: [
        "Step-up transformer",
        "Step-down transformer",
        "Isolation transformer",
        "Auto transformer"
      ],
      correct: "Step-up transformer",
    },
    {
      question: "What is the main function of a ring main unit (RMU) in a solar substation?",
      options: [
        "To provide protection and sectionalization in medium-voltage distribution",
        "To control DC circuit voltage",
        "To distribute AC loads in homes",
        "To measure solar irradiance"
      ],
      correct: "To provide protection and sectionalization in medium-voltage distribution",
    },
    {
      question: "Which factor most affects inverter lifetime in utility-scale systems?",
      options: [
        "Thermal management and ambient temperature",
        "Cable insulation thickness",
        "Solar panel wattage",
        "Humidity levels alone"
      ],
      correct: "Thermal management and ambient temperature",
    },
    {
      question: "What is the main function of a capacitor bank in a grid-tied PV system?",
      options: [
        "To improve power factor and voltage stability",
        "To store excess DC energy",
        "To regulate inverter frequency",
        "To balance string currents"
      ],
      correct: "To improve power factor and voltage stability",
    },
    {
      question: "What does the term 'curtailment' mean in solar grid operations?",
      options: [
        "Intentional reduction of solar power output due to grid constraints",
        "Energy loss due to panel shading",
        "Reduction of inverter efficiency",
        "Disconnection due to overcurrent"
      ],
      correct: "Intentional reduction of solar power output due to grid constraints",
    },
    {
      question: "What type of loss occurs due to inverter self-consumption and transformer inefficiency?",
      options: [
        "Auxiliary losses",
        "Soiling losses",
        "Mismatch losses",
        "Reflection losses"
      ],
      correct: "Auxiliary losses",
    },
    {
      question: "Which international standard governs performance monitoring of PV systems?",
      options: [
        "IEC 61724",
        "IEC 62446",
        "IEC 61215",
        "IEC 61683"
      ],
      correct: "IEC 61724",
    },
  ],
},


{
  level: 9,
  title: "Mythic",
  rankTitle: "Solar Sage",
  questions: [
    {
      question: "In a hybrid solar setup, what happens if both grid and solar inputs are present simultaneously?",
      options: [
        "The inverter prioritizes grid power",
        "The inverter prioritizes solar power",
        "Both sources supply the load equally",
        "The system shuts down to avoid conflict"
      ],
      correct: "The inverter prioritizes solar power",
    },
    {
      question: "Which solar inverter topology provides maximum redundancy for large commercial systems?",
      options: [
        "Centralized inverter topology",
        "String inverter topology",
        "Modular multi-string topology",
        "Hybrid topology with microinverters"
      ],
      correct: "Modular multi-string topology",
    },
    {
      question: "In high-temperature regions, which of the following best mitigates panel performance loss?",
      options: [
        "Using panels with lower NOCT values",
        "Increasing array tilt",
        "Oversizing the inverter",
        "Using thicker wiring"
      ],
      correct: "Using panels with lower NOCT values",
    },
    {
      question: "When performing an insulation resistance test on PV strings, what is the minimum acceptable resistance?",
      options: [
        "0.5 MΩ",
        "1 MΩ",
        "10 MΩ",
        "50 MΩ"
      ],
      correct: "1 MΩ",
    },
    {
      question: "What causes PID (Potential Induced Degradation) in solar panels?",
      options: [
        "Poor grounding and high voltage potential difference",
        "Microcracks from transport",
        "UV degradation on backsheet",
        "High humidity inside junction box"
      ],
      correct: "Poor grounding and high voltage potential difference",
    },
    {
      question: "A combiner box fuse rating should be chosen based on:",
      options: [
        "Panel maximum power voltage",
        "Panel short circuit current",
        "Array open circuit voltage",
        "Inverter input current"
      ],
      correct: "Panel short circuit current",
    },
    {
      question: "Which communication protocol is most commonly used in advanced solar monitoring systems?",
      options: [
        "RS-232",
        "RS-485",
        "CANbus",
        "Modbus RTU"
      ],
      correct: "Modbus RTU",
    },
    {
      question: "What effect does reverse polarity have on solar installations if diodes fail?",
      options: [
        "Power loss without damage",
        "Hot spot formation and potential fire risk",
        "Reduced voltage output only",
        "No significant effect"
      ],
      correct: "Hot spot formation and potential fire risk",
    },
    {
      question: "In a grid-tied system with net metering, what happens when solar generation exceeds load consumption?",
      options: [
        "The inverter shuts down",
        "Excess power is exported to the grid",
        "Excess power is wasted as heat",
        "The inverter limits its output"
      ],
      correct: "Excess power is exported to the grid",
    },
    {
      question: "What component ensures synchronization between inverter and grid frequency?",
      options: [
        "PLL (Phase Locked Loop)",
        "MPPT tracker",
        "DC bus controller",
        "PWM driver"
      ],
      correct: "PLL (Phase Locked Loop)",
    },
    {
      question: "Which testing method verifies correct polarity of solar strings?",
      options: [
        "I-V curve tracing",
        "Continuity test with multimeter",
        "Megger insulation test",
        "Earth resistance test"
      ],
      correct: "Continuity test with multimeter",
    },
    {
      question: "What’s the primary function of a dump load in an off-grid wind-solar hybrid system?",
      options: [
        "To increase voltage",
        "To consume excess energy to protect the battery bank",
        "To divert power to inverter",
        "To stabilize PV output"
      ],
      correct: "To consume excess energy to protect the battery bank",
    },
    {
      question: "What is the main cause of a ground fault in PV systems?",
      options: [
        "Loose terminals",
        "Degraded insulation on conductors",
        "Incorrect polarity connection",
        "Overcurrent protection failure"
      ],
      correct: "Degraded insulation on conductors",
    },
    {
      question: "Which of the following most affects inverter lifespan?",
      options: [
        "Ambient temperature and cooling design",
        "PV panel brand",
        "Cable length",
        "Mounting structure material"
      ],
      correct: "Ambient temperature and cooling design",
    },
    {
      question: "A system using 24V battery and 60-cell panels requires how many panels in series for proper charging?",
      options: [
        "1",
        "2",
        "3",
        "4"
      ],
      correct: "2",
    },
    {
      question: "When installing panels in parallel strings, mismatch losses can be minimized by:",
      options: [
        "Using identical modules and equal cable lengths",
        "Tilting arrays differently",
        "Using panels with mixed wattages",
        "Installing more bypass diodes"
      ],
      correct: "Using identical modules and equal cable lengths",
    },
    {
      question: "Which device isolates PV arrays during emergency maintenance?",
      options: [
        "Isolator switch (DC disconnect)",
        "Surge arrestor",
        "Ground fault detector",
        "Inverter circuit breaker"
      ],
      correct: "Isolator switch (DC disconnect)",
    },
    {
      question: "How can one detect partial shading losses most effectively?",
      options: [
        "With I-V curve tracing",
        "By measuring open circuit voltage only",
        "By inspecting wiring visually",
        "By checking inverter LED indicators"
      ],
      correct: "With I-V curve tracing",
    },
    {
      question: "Which inverter parameter must match the grid’s to ensure synchronization?",
      options: [
        "Frequency and phase",
        "Only current",
        "Only voltage",
        "DC bus voltage"
      ],
      correct: "Frequency and phase",
    },
    {
      question: "A PV plant monitoring system that sends real-time data to the cloud uses which setup?",
      options: [
        "Data logger with internet gateway",
        "Standalone inverter",
        "Battery management system",
        "Combiner box"
      ],
      correct: "Data logger with internet gateway",
    }
  ],
},



{
  level: 10,
  title: "Legendary",
  rankTitle: "Solar Grandmaster",
  questions: [
    {
      question: "Which IEC standard defines general requirements for grid-connected photovoltaic inverters?",
      options: [
        "IEC 61727",
        "IEC 62109-1",
        "IEC 62446",
        "IEC 60068"
      ],
      correct: "IEC 61727",
    },
    {
      question: "In large PV farms, string mismatch can reduce total array yield by approximately:",
      options: [
        "0.5–1%",
        "2–3%",
        "5–10%",
        "10–20%"
      ],
      correct: "2–3%",
    },
    {
      question: "What does an I-V curve flattening near Voc typically indicate?",
      options: [
        "Series resistance loss",
        "Shunt resistance loss",
        "Panel overheating",
        "Bypass diode short"
      ],
      correct: "Shunt resistance loss",
    },
    {
      question: "What is the main difference between MPPT and PWM charge controllers in voltage regulation?",
      options: [
        "MPPT converts excess voltage to current, PWM limits voltage to battery level",
        "MPPT operates only on AC, PWM on DC",
        "PWM has higher efficiency than MPPT",
        "MPPT requires no sensors"
      ],
      correct: "MPPT converts excess voltage to current, PWM limits voltage to battery level",
    },
    {
      question: "In a three-phase solar inverter, phase imbalance beyond what percentage usually triggers a fault?",
      options: [
        "2%",
        "5%",
        "10%",
        "15%"
      ],
      correct: "10%",
    },
    {
      question: "Which solar cell technology has the highest theoretical efficiency limit under single junction conditions?",
      options: [
        "Monocrystalline silicon",
        "Polycrystalline silicon",
        "CdTe thin film",
        "Gallium arsenide (GaAs)"
      ],
      correct: "Gallium arsenide (GaAs)",
    },
    {
      question: "What’s the typical cause of rapid voltage drop under load in lithium battery banks?",
      options: [
        "Weak cell balancing or BMS current limit",
        "Excess solar input",
        "Poor inverter grounding",
        "High PV array voltage"
      ],
      correct: "Weak cell balancing or BMS current limit",
    },
    {
      question: "Which parameter is most useful in predicting solar system degradation over time?",
      options: [
        "Performance Ratio (PR)",
        "Array-to-inverter ratio",
        "Module efficiency rating",
        "Short-circuit current (Isc)"
      ],
      correct: "Performance Ratio (PR)",
    },
    {
      question: "What component in modern inverters reduces Total Harmonic Distortion (THD)?",
      options: [
        "LCL filter",
        "Snubber circuit",
        "DC link capacitor",
        "PWM driver"
      ],
      correct: "LCL filter",
    },
    {
      question: "What’s the most effective mitigation against lightning-induced surges in solar arrays?",
      options: [
        "Proper earthing and surge protection devices at array junctions",
        "Using thicker DC cables",
        "Installing bypass diodes on each panel",
        "Increasing panel distance from ground"
      ],
      correct: "Proper earthing and surge protection devices at array junctions",
    },
    {
      question: "When paralleling multiple inverters, what is critical for stable operation?",
      options: [
        "Synchronization of frequency and phase angle",
        "Equal battery sizes",
        "Matching PV panel wattages",
        "Using identical grounding rods"
      ],
      correct: "Synchronization of frequency and phase angle",
    },
    {
      question: "A PV system producing less than 75% of expected output under clear sky likely indicates:",
      options: [
        "Dirty modules or partial shading",
        "Inverter over-sizing",
        "Higher battery capacity",
        "Cable length below standard"
      ],
      correct: "Dirty modules or partial shading",
    },
    {
      question: "Which of these best describes clipping losses in PV systems?",
      options: [
        "Losses from inverter limiting DC input exceeding its AC output capacity",
        "Energy lost due to shading",
        "Heat loss from cables",
        "Degradation losses due to PID"
      ],
      correct: "Losses from inverter limiting DC input exceeding its AC output capacity",
    },
    {
      question: "What is the recommended distance between parallel DC cables to minimize inductive coupling?",
      options: [
        "5 cm",
        "10 cm",
        "20 cm",
        "As close as possible (bundled)"
      ],
      correct: "As close as possible (bundled)",
    },
    {
      question: "What happens when inverter firmware is incompatible with the grid’s voltage-frequency window?",
      options: [
        "Frequent grid disconnection errors",
        "Reduced power output only",
        "Inverter operates in island mode",
        "MPPT failure"
      ],
      correct: "Frequent grid disconnection errors",
    },
    {
      question: "In large battery banks, temperature compensation is essential to:",
      options: [
        "Prevent overcharging or undercharging due to temperature variations",
        "Improve inverter frequency response",
        "Boost solar input voltage",
        "Reduce surge current"
      ],
      correct: "Prevent overcharging or undercharging due to temperature variations",
    },
    {
      question: "The phenomenon where inverter shuts down due to exceeding reactive power limits is called:",
      options: [
        "Volt-Var trip",
        "Power factor drift",
        "Grid surge fault",
        "Harmonic isolation"
      ],
      correct: "Volt-Var trip",
    },
    {
      question: "In designing PV systems, derating factors typically account for:",
      options: [
        "Real-world losses from temperature, wiring, dust, and inverter efficiency",
        "Grid regulation penalties",
        "Wind and vibration losses",
        "Ground resistance limits"
      ],
      correct: "Real-world losses from temperature, wiring, dust, and inverter efficiency",
    },
    {
      question: "Which testing tool provides the most accurate verification of inverter MPPT performance?",
      options: [
        "I-V curve tracer",
        "Multimeter",
        "Clamp ammeter",
        "Insulation tester"
      ],
      correct: "I-V curve tracer",
    },
    {
      question: "During inverter commissioning, anti-islanding protection is tested to ensure:",
      options: [
        "The inverter stops exporting power when grid supply fails",
        "Panels continue feeding local loads when grid is off",
        "Battery remains charged during grid outage",
        "MPPT controllers adjust to local consumption"
      ],
      correct: "The inverter stops exporting power when grid supply fails",
    }
  ],
}




  // Add up to level 5
];
